import {times} from 'lodash';
import faker from 'faker';
import {ENDPOINTS} from '~/constants';

const medicationItem = () => ({
  id: 0,
  name: faker.lorem.sentence(),
});

const medications = {
  [ENDPOINTS.MEDICATIONS]: {
    get: times(5, Number).map(i => ({...medicationItem(), id: i + 2})),
  },
};

export default medications;
